// These are the commonly expected values for style set by the old editor, used for backward compatibility
export const LEFT_ALIGNED = "display: inline; float: left; margin: 0px 1em 1em 0px;";
export const RIGHT_ALIGNED = "display: inline; float: right; margin: 0px 0px 1em 1em;";
export const CENTER_ALIGNED = "display: block; margin: auto;";

/**
 * Returns the image alignment based on "display"- and "float"- or "margin"-attributes.
 *
 * @param {string | null} styles
 * @returns {null | "display: inline; float: left; margin: 0px 1em 1em 0px;" | "display: inline; float: right; margin: 0px 0px 1em 1em;" | "display: block; margin: auto;"}
 */
export function getAlignmentStyle(styles) {
  if (!styles) {
    return null;
  }
  const split = styles.split(";");
  let display, float, margin;
  for (const style of split) {
    const trimmed = style.trim();
    if (trimmed.startsWith("display:")) {
      display = trimmed.slice(8).trimStart();
    } else if (trimmed.startsWith("float:")) {
      float = trimmed.slice(6).trimStart();
    } else if (trimmed.startsWith("margin:")) {
      margin = trimmed.slice(7).trimStart();
    }
  }
  if (display === "inline") {
    if (float === "left") {
      return LEFT_ALIGNED;
    } else if (float === "right") {
      return RIGHT_ALIGNED;
    }
  } else if (display === "block" && margin === "auto") {
    return CENTER_ALIGNED;
  }
  return null;
}

